import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import UIButton from 'UIComponents/button/UIButton';
import styled from 'academy-common-lib/utils/Styling';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIToggle from 'UIComponents/input/UIToggle';
import UILink from 'UIComponents/link/UILink';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const ThemedPrimaryButtonMixin = props => props.theme.activeTheme === 'highContrast' && `
  background-color: ${props.theme.colors.HIGH_CONTRAST_PRIMARY} !important;
  border-color: ${props.theme.colors.HIGH_CONTRAST_PRIMARY} !important;

  &:hover {
    background-color: ${props.theme.colors.HIGH_CONTRAST_HOVER} !important;
    border-color: ${props.theme.colors.HIGH_CONTRAST_HOVER} !important;
    color: ${props.theme.colors.HIGH_CONTRAST_PRIMARY} !important;
  }
`;
export const ThemedSecondaryButtonMixin = props => props.theme.activeTheme === 'highContrast' && `
  color: ${props.theme.colors.HIGH_CONTRAST_PRIMARY} !important;
  border-color: ${props.theme.colors.HIGH_CONTRAST_PRIMARY} !important;

  &:hover {
    background-color: ${props.theme.colors.HIGH_CONTRAST_HOVER} !important;
  }
`;
export const ThemedLinkMixin = props => props.theme.activeTheme === 'highContrast' && `
  color: ${props.theme.colors.HIGH_CONTRAST_LINK} !important;
`;
export const ThemedLinkButton = styled(UIButton).attrs({
  use: 'link'
}).withConfig({
  displayName: "ThemedComponents__ThemedLinkButton",
  componentId: "m11xj5-0"
})(["", ""], ThemedLinkMixin);
export const ThemedLink = styled(UILink).withConfig({
  displayName: "ThemedComponents__ThemedLink",
  componentId: "m11xj5-1"
})(["", ""], ThemedLinkMixin);
export const ThemedRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemedComponents__ThemedRouterLink",
  componentId: "m11xj5-2"
})(["", ""], ThemedLinkMixin);
export const ThemedPrimaryButton = styled(UIButton).attrs({
  use: 'primary'
}).withConfig({
  displayName: "ThemedComponents__ThemedPrimaryButton",
  componentId: "m11xj5-3"
})(["", ""], ThemedPrimaryButtonMixin);
export const ThemedPrimaryRouterButton = styled(UIRouterButton).attrs({
  use: 'primary'
}).withConfig({
  displayName: "ThemedComponents__ThemedPrimaryRouterButton",
  componentId: "m11xj5-4"
})(["", ""], ThemedPrimaryButtonMixin);
export const ThemedSecondaryButton = styled(UIButton).attrs({
  use: 'secondary'
}).withConfig({
  displayName: "ThemedComponents__ThemedSecondaryButton",
  componentId: "m11xj5-5"
})(["", ""], ThemedSecondaryButtonMixin);
export const ThemedDropdown = styled(_ref => {
  let {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(UIDropdown, Object.assign({
    buttonClassName: className
  }, props));
}).attrs({
  buttonUse: 'transparent'
}).withConfig({
  displayName: "ThemedComponents__ThemedDropdown",
  componentId: "m11xj5-6"
})(["", ""], props => props.theme.activeTheme === 'highContrast' && `
  color: ${props.theme.colors.HIGH_CONTRAST_LINK} !important;
  `);
export const ThemedToggle = styled(UIToggle).withConfig({
  displayName: "ThemedComponents__ThemedToggle",
  componentId: "m11xj5-7"
})(["", ""], props => props.theme.activeTheme === 'highContrast' && `
  .uiToggleSwitchOn {
    background-color: ${props.theme.colors.HIGH_CONTRAST_LINK} !important;

    [class*='UIToggle__Handle'] {
      box-shadow: 0 0 0 1px ${props.theme.colors.HIGH_CONTRAST_LINK},
        0 5px 5px 0 rgba(0, 0, 0, 0.08);
    }

    path {
      fill: ${props.theme.colors.HIGH_CONTRAST_LINK} !important;
    }
  }
  `);